import { render, staticRenderFns } from "./SettingSendgrid.vue?vue&type=template&id=e9fe13be"
import script from "./SettingSendgrid.vue?vue&type=script&lang=js"
export * from "./SettingSendgrid.vue?vue&type=script&lang=js"
import style0 from "./SettingSendgrid.vue?vue&type=style&index=0&id=e9fe13be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports